/* eslint-disable @typescript-eslint/promise-function-async */
import { Routes } from '@angular/router';
import { NavigationGuard } from '@core/guards/navigation.guard';
import { RoutePaths } from '@global/routePaths';

export const DiscontinuePolicyRoutes: Routes = [
  {
    path: RoutePaths.MODIFY_POLICY.DISCONTINUE.DISCONTINUE_POLICY_SUMMARY.route,
    loadChildren: () =>
      import('@pages/discontinue-policy/discontinue-summary/discontinue-summary.module').then(
        m => m.DiscontinuePolicySummaryPageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.MODIFY_POLICY.DISCONTINUE.DISCONTINUE_POLICY_REASON.route,
    loadChildren: () =>
      import('@pages/discontinue-policy/discontinue-reason/discontinue-reason.module').then(
        m => m.DiscontinueReasonsPageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.MODIFY_POLICY.DISCONTINUE.DISCONTINUE_POLICY_REASON_DETAIL.route,
    loadChildren: () =>
      import('@pages/discontinue-policy/discontinue-reason-detail/discontinue-reason-detail.module').then(
        m => m.DiscontinueReasonsDetailPageModule
      ),
    canActivate: [NavigationGuard],
  },
];
